import {Grid, Typography} from "@mui/material";
import Lista_Proyectos from "./Componentes/SubComponentes/Lista_Proyectos";
import {useNavigate} from "react-router-dom";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import Otros_Home from "./Componentes/Otros_Home";
import proyecto1 from "../../Recursos/proyecto1.png";
import proyecto2 from "../../Recursos/proyecto2.png";
import proyecto3 from "../../Recursos/proyecto3.png";
import proyecto4 from "../../Recursos/proyecto4.png";
import proyecto5 from "../../Recursos/proyecto5.png";
import proyecto6 from "../../Recursos/proyecto6.png";

import otros1 from '../../Recursos/otros1.png'
import otros2 from '../../Recursos/otros2.png'
import otros3 from '../../Recursos/otros3.png'
import otros4 from '../../Recursos/otros4.png'
import otros5 from '../../Recursos/otros5.png'
import otros6 from '../../Recursos/otros6.png'

const items1 = [
    {
        imagen: proyecto1,
        tipo: "PÁGINA WEB",
        titulo: "drhernanjojoa.com",
        descripcion: "Portafolio de servicios y casos de pacientes y blog",
        link: "https://drhernanjojoa.com/"
    },
    {
        imagen: proyecto2,
        tipo: "PORTAFOLIO DE ARQUITECTURA",
        titulo: "espaciocompacto.com",
        descripcion: "Portafolio de proyectos y blog",
        link: "https://espaciocompacto.com"
    },
    {
        imagen: proyecto3,
        tipo: "MENÚ PARA RESTAURANTES",
        titulo: "toppings.com.co",
        descripcion: "Menú digital con QR fácil de actualizar para mejorar la experiencia del cliente",
        link: "https://toppings.com.co"
    },
    {
        imagen: proyecto4,
        tipo: "TIENDA ONLINE",
        titulo: "fairytail.store",
        descripcion: "Mejorar la experiencia de compra al clientes.",
        link: "https://fairytail.store"
    },
    {
        imagen: proyecto5,
        tipo: "MENÚ PARA RESTAURANTES",
        titulo: "pistonparrilla.com.co",
        descripcion: "Menú digital con QR fácil de actualizar para mejorar la experiencia del cliente",
        link: "https://pistonparrilla.com.co/"
    },
    {
        imagen: proyecto6,
        tipo: "EXPERIENCIA INMERSIVA EN TURISMO",
        titulo: "kindiyaku.com.co",
        descripcion: "Experiencia inmersiva con AR, y fotos 360",
        link: "https://kindiyaku.com.co"
    }
];

const items2 = [
    {
        imagen: otros1,
        tipo: "PÁGINA WEB",
        titulo: "congenar.com",
        descripcion: "Mejorar la experiencia de compra al clientes.",
        link: "https://www.congenar.com/"
    },
    {
        imagen: otros2,
        tipo: "PORTAFOLIO DE ARQUITECTURA",
        titulo: "hotelmarazultumaco.com",
        descripcion: "Mejorar la experiencia de compra al clientes.",
        link: "https://hotelmarazultumaco.com/"
    },
    {
        imagen: otros3,
        tipo: "MENÚ PARA RESTAURANTES",
        titulo: "grupoburaz.com",
        descripcion: "Canal de comunicación",
        link: "//www.grupoburaz.com/"
    },
    {
        imagen: otros4,
        tipo: "TIENDA ONLINE",
        titulo: "ecofuelmanager.com",
        descripcion: "Página web",
        link: "//ecofuelmanager.com/"
    },
    {
        imagen: otros5,
        tipo: "MENÚ PARA RESTAURANTES",
        titulo: "asocargan.org",
        descripcion: "Canal de comunicación e información",
        link: "https://asocargan.org/"
    },
    {
        imagen: otros6,
        tipo: "EXPERIENCIA INMERSIVA EN TURISMO",
        titulo: "trespagos.com",
        descripcion: "Plataforma de financiamiento y pagos",
        link: "https://trespagos.com/"
    }
];


const Seccion_Trabajo = () => {

    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>
            <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{ pt: sCell ? 16 : 16, pb:16, px: 3,}}>

                <Grid container justifyContent={'flex-start '} size={{xs: 12, sm: 12, md: 12}} >
                    <Typography variant={'h3'}>
                      Diseño UX/UI | Desarrollador Web
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt: 4}}>
                    <Lista_Proyectos items={items1} />
                </Grid>

                <Grid container justifyContent={'flex-start '} size={{xs: 12, sm: 12, md: 12}} sx={{ pt:8}}>
                    <Typography variant={'h3'}>
                       Desarrollador Front-end
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt: 4}}>
                    <Lista_Proyectos items={items2} />
                </Grid>


                {/*<Grid size={{xs: 12, sm: 12, md: 12}} sx={{pt:16}}>*/}
                {/*    <Otros_Home/>*/}
                {/*</Grid>*/}

            </Grid>

        </Grid>
    )

}
export default Seccion_Trabajo